<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "SettingAdvanced"
})
</script>

<template>
  <div>set ad</div>

</template>

<style scoped>

</style>